import React from 'react';
import {useTranslation} from 'react-i18next';
import {useQuery} from '@tanstack/react-query';
import {Housing} from '@guestapp/sdk';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';
import HousingLogo from 'assets/img/test-housing-Logo.svg';
import {SideBarContainer, SideBarLogo, SideBarPropertyName, SideBarTitle} from './styled';

function SideBarUniversalLink() {
  const {t} = useTranslation();
  const {objectId, getHousing} = useChekinSDK();
  const housingId = objectId;

  const {data: housing} = useQuery<Housing, Error>(
    [QUERY_CACHE_KEYS.housing],
    () => getHousing(housingId || ''),
    {
      initialData: {} as Housing,
      enabled: Boolean(housingId),
    },
  );

  const logo = housing.picture?.src;
  const title = housing.display_name ?? housing.name;

  return (
    <SideBarContainer>
      <SideBarTitle>{t('welcome_to')}</SideBarTitle>
      <SideBarLogo src={logo ? logo : HousingLogo} alt="" />
      <SideBarPropertyName>{title}</SideBarPropertyName>
    </SideBarContainer>
  );
}

export {SideBarUniversalLink};
